import { useDispatch } from 'react-redux';
import { addNotification } from '../store/reducers/uiReducer';

export const useShowNotification = (title = 'App', icon = 'gift') => {
    const dispatch = useDispatch();
    return (message, type = 'primary') => {
        dispatch(
            addNotification({
                icon,
                type,
                title,
                message
            })
        );
    };
};
